import { fetchProducts } from "../api";

export default {
    namespaced: true,

    state: {
        all: [],
    },

    getters: {
        productAmount: (state) => {
            return state.all.length;
        }
    },

    actions: {
        async fetch({ commit, rootState }, stepsTaken) {
            const { data } = await fetchProducts(stepsTaken, rootState.environment);
            commit('setProducts', data);
        },
        clear: ({ commit }) => {
            return commit('setProducts', []);
        }
    },

    mutations: {
        setProducts: (state, products) => {
            state.all = products;
        },
    },
};
